/**
 * Calendar days as `YYYY-MM-DD`, in the browser's own time zone.
 *
 * Not `toISOString().slice(0, 10)`: that is UTC, and for most of an Indian
 * evening it is already tomorrow's date there - a filter that says "today" and
 * means yesterday's invoices or tomorrow's.
 */
export const isoDay = (date: Date = new Date()): string => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

/** The day `days` before today (`daysAgo(0)` is today). */
export const daysAgo = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return isoDay(date);
};
